
import _ from 'lodash';

const namespaced = true;

const state = {
  projects: [],
  interventions: [],
};

const mutations = {
  SET_PROJECTS(state, projects) {
    state.projects = projects;
  },
  SET_INTERVENTIONS(state, interventions) {
    state.interventions = interventions;
  },
};

const actions = {
  async fetchProjects({ dispatch, commit }) {
    const projects = await dispatch(`model/project/fetchList`, null, { root: true });

    commit(`SET_PROJECTS`, projects);
  },
  async fetchInterventions({ dispatch, commit }, { from, to }) {
    const interventions = await dispatch(`model/intervention/fetchList`, {
      queryParams: { from, to },
    }, { root: true });

    commit(`SET_INTERVENTIONS`, interventions);
  },
  fetchUsers({ rootState, dispatch }) {
    const clientId = rootState[`model/client`].company.id;
    return dispatch(`model/user/fetchUsers`, clientId, { root: true });
  },
  updateInterventionLocally({ state, commit }, intervention) {
    const interventions = _.clone(state.interventions);
    const interventionIndex = _.findIndex(interventions, { id: intervention.id });

    interventions[interventionIndex] = intervention;
    commit(`SET_INTERVENTIONS`, interventions);
  },
  async updateIntervention({ state, dispatch }, intervention) {
    if (_.isNumber(intervention)) {
      intervention = _.find(state.interventions, { id: intervention });
    }

    const dbIntervention = await dispatch(`model/intervention/updateIntervention`, intervention, { root: true });

    dispatch(`updateInterventionLocally`, dbIntervention);
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
